import { CMSApiBase, CMSArrayBase, CMSImageBase, createCmsUrl } from './base';
import { fetcherCMS } from '@/modules/api';
import { getCMSLocale } from '@/modules/cms';

interface Benefits extends CMSArrayBase {
  title: string;
  text: string;
  icon: CMSImageBase;
}

export interface OurBenefits extends CMSApiBase {
  title: string;
  benefits: Benefits[];
}

export const getOurBenefitsCMSUrl = (lang: string) =>
  createCmsUrl({
    path: 'our-benefit',
    queryData: { populate: 'deep', ...getCMSLocale(lang) },
  });

export const fetchOurBenefitsCMS = async (lang: string) => {
  const response = await fetcherCMS<OurBenefits>(getOurBenefitsCMSUrl(lang));
  return { data: response };
};
